import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

const functions = getFunctions(app, 'us-central1');
const sendServiceRequest = httpsCallable(functions, 'sendServiceRequest');

export async function submitServiceRequest(form, serviceType) {
  const formData = new FormData(form);
  const request = Object.fromEntries(formData.entries());

  await sendServiceRequest({ ...request, serviceType });
}
